// ─── Constants shared across multiple views ───────────────────────────────────

// Canonical filter label set — mirrors backend ALLOWED_TIERS in
// controller/accountController.js and controller/userController.js exactly.
// No label here may ever be one the API rejects (see helper/tiers.js).
export const LICENSE_TIERS = ['Starter', 'Adviser', 'Elite', 'Elite (legacy)', 'Essential (legacy)', 'None'];

export const PAGE_SIZES = [25, 50, 100];
